import {
  BasePriceKeyListMap,
  getPlatformContentLabelI18n
} from '@/interface/common';
export { formatSingleBraceTemplate } from '@/utils/formatSingleBraceTemplate';

export const getCreatorPlacementContentTypeLabel = ({
  platform,
  contentType,
  t
}: {
  platform?: string;
  contentType?: string;
  t: (key: string) => string;
}) => {
  if (!contentType) return '';
  const canonicalPlatform = String(platform ?? '')
    .trim()
    .toLowerCase();
  const canonicalContentType =
    BasePriceKeyListMap[canonicalPlatform]?.[contentType] ?? contentType;
  return getPlatformContentLabelI18n(canonicalContentType, t) ?? contentType;
};

/**
 * Compact content-type copy used by the delivery, AI review and submission
 * history designs. The offer cards intentionally keep their longer product
 * names (for example "Short video"), while these flows use the shorter
 * Figma labels: Dedicated / Integrated / Video / Reel.
 */
export const getCreatorDeliveryContentTypeLabel = ({
  platform,
  contentType
}: {
  platform?: string;
  contentType?: string;
}) => {
  const canonicalPlatform = String(platform ?? '')
    .trim()
    .toLowerCase();
  const canonicalContentType = String(contentType ?? '')
    .trim()
    .toLowerCase();

  if (canonicalPlatform === 'youtube') {
    return canonicalContentType.includes('integrated')
      ? 'Integrated'
      : 'Dedicated';
  }
  if (canonicalPlatform === 'tiktok') return 'Video';
  if (canonicalPlatform === 'instagram') return 'Reel';
  return contentType || '';
};
